import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const primaryStyles = css `
  color: ${theme.semantic.foreground.inverse};
  background-color: ${theme.semantic.action.primary.default};
  border-color: ${theme.swatches.warm[1000]};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }

  &:disabled {
    background-color: ${theme.semantic.action.primary.default};
    color: ${theme.semantic.foreground.inverse};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      border-color: ${theme.swatches.warm[800]};
      background-color: ${theme.swatches.warm[800]};
    }

    &:active {
      border-color: ${theme.swatches.warm[700]};
      background-color: ${theme.swatches.warm[700]};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
    }
  }
`;
const secondaryStyles = css `
  color: ${theme.semantic.foreground.secondary};
  background-color: ${theme.semantic.action.secondary.default};
  border-color: ${theme.semantic.border.default};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.tertiary};
  }

  &:disabled {
    color: ${theme.semantic.foreground.secondary};
    background-color: ${theme.semantic.action.secondary.default};
    border-color: ${theme.semantic.border.default};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${theme.semantic.action.secondary.hover};
      border-color: ${theme.semantic.border.default};
    }

    &:active {
      background-color: ${theme.semantic.action.secondary.active};
      border-color: ${theme.semantic.border.default};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
    }
  }
`;
const ghostStyles = css `
  color: ${theme.semantic.foreground.secondary};
  background-color: transparent;
  border-color: transparent;

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.tertiary};
  }

  &:disabled {
    opacity: 0.5;
    color: ${theme.semantic.foreground.secondary};
    background-color: transparent;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${theme.semantic.action.secondary.hover};
      border-color: ${theme.semantic.border.default};
    }

    &:active {
      background-color: ${theme.swatches.gray[200]};
      border-color: ${theme.semantic.border.default};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
    }
  }
`;
const glassStyles = css `
  color: ${theme.semantic.foreground.inverse};
  background-color: color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 95%);
  border-color: color-mix(in srgb, ${theme.swatches.gray[0]}, transparent 95%);

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }

  &:disabled {
    opacity: 0.5;
    color: ${theme.semantic.foreground.inverse};
    background-color: transparent;
  }

  &:not(:disabled) {
    &:hover {
      background-color: color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 90%);
      border-color: color-mix(in srgb, ${theme.swatches.gray[0]}, transparent 90%);
    }

    &:active {
      background-color: color-mix(in srgb, ${theme.semantic.foreground.inverse}, transparent 80%);
      border-color: color-mix(in srgb, ${theme.swatches.gray[0]}, transparent 80%);
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
    }
  }
`;
const dangerStyles = css `
  color: ${theme.semantic.foreground.inverse};
  background-color: ${theme.swatches.red[500]};
  border-color: ${theme.swatches.red[500]};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }

  &:disabled {
    background-color: ${theme.swatches.red[500]};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${theme.swatches.red[400]};
    }

    &:active {
      background-color: ${theme.swatches.red[600]};
    }

    &:focus-visible {
      background-color: ${theme.swatches.red[500]};
      box-shadow: 0 0 0 ${pxToRem(2)} ${theme.swatches.red[200]};
    }
  }
`;
export function getButtonAppearance(appearance) {
    switch (appearance) {
        case 'secondary':
            return secondaryStyles;
        case 'ghost':
            return ghostStyles;
        case 'glass':
            return glassStyles;
        case 'danger':
            return dangerStyles;
        case 'primary':
        default:
            return primaryStyles;
    }
}
